import { SVGProps } from '../types';

const MastercardIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M28.7695 6.7066C33.7627 6.7066 37.8105 10.7065 37.8105 15.6402C37.8104 20.5738 33.7626 24.5728 28.7695 24.5728C26.5311 24.5728 24.4842 23.7676 22.9053 22.4361C21.3264 23.7676 19.2795 24.5728 17.041 24.5728C12.0479 24.5728 8.00014 20.5738 8 15.6402C8 10.7065 12.0479 6.7066 17.041 6.7066C19.2794 6.70663 21.3264 7.51196 22.9053 8.84332C24.4841 7.51196 26.5312 6.70664 28.7695 6.7066Z"
      fill="#ED0006"
    />
    <path
      d="M28.7695 6.7066C33.7627 6.7066 37.8105 10.7065 37.8105 15.6402C37.8104 20.5738 33.7626 24.5728 28.7695 24.5728C26.5311 24.5728 24.4842 23.7676 22.9053 22.4361C24.8482 20.7976 26.082 18.362 26.082 15.6402C26.082 12.9182 24.8484 10.4819 22.9053 8.84332C24.4842 7.51196 26.5312 6.70663 28.7695 6.7066Z"
      fill="#F9A000"
    />
    <path
      d="M22.9048 8.84363C24.848 10.4821 26.0814 12.9176 26.0815 15.6395C26.0815 18.3615 24.8479 20.7969 22.9048 22.4354C20.9622 20.7969 19.729 18.3611 19.729 15.6395C19.7291 12.918 20.9621 10.4821 22.9048 8.84363Z"
      fill="#FF5E00"
    />
  </svg>
);

export { MastercardIcon };
